<template>
  <transition name="modal-fade">
    <div class="modal" tabindex="-1">
      <div class="modal-dialog modal-bill-print modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-heading">
            <div class="bill-text-status" v-if="billModal == 'reprint'">
              <span v-translate>Copy bill</span>
            </div>
            <div class="bill-text-status" v-else-if="isBill('voided')">
              <span v-translate>Void bill</span>
            </div>
            <div class="bill-text-status" v-else-if="isBill('closed')">
              <span v-translate>Paid bill</span>
            </div>
            <div v-if="isBill('voided')">
              <p class="bill-text-note" v-if="bill.statusNote">{{ bill.statusNote }}</p>
            </div>
            <div class="row bill-header">
              <div class="col">
                <span class="text-capitalize" v-translate>Bill no</span>
                <br />
                <big>{{ bill.number }}</big>
              </div>
              <div class="col" v-if="bill.table">
                <span v-translate>Table</span>
                <br />
                <big>{{ bill.table }}</big>
              </div>
              <div class="col" v-if="bill.room">
                <span v-translate>Room</span>
                <br />
                <big>{{ bill.room }}</big>
              </div>
              <div class="col" v-if="bill.cover">
                <span v-translate>Cover</span>
                <br />
                <big>{{ bill.cover }}</big>
              </div>
              <div class="col">
                <span v-translate>Staff ID</span>
                <br />
                <big>{{ printProperty(bill.staff, 'staffs', 'ref') }}</big>
              </div>
            </div>
            <template v-if="groupViewed == groupedOrder.length">
              <hr class="hr-dashed" />
              <div class="d-flex align-items-center">
                <div class="store-info">
                  <span>
                    <icon name="location-pin" class="bill-modal-phone" />
                    {{ location.address }}
                  </span>
                  <br />
                  <span>
                    <icon name="phone" class="bill-modal-phone" />
                    {{ location.phone }}
                  </span>
                </div>
                <div class="store-logo ml-auto">
                  <span class="store-name">{{ location.name }}</span>
                  <br />
                  <span>{{ station.name }}</span>
                  <br />
                </div>
              </div>
              <hr class="hr-dashed" />
              <div class="row">
                <div class="col">
                  <span v-if="bill.customer" v-translate>Customer Name:</span>
                  <br />
                  <span
                    class="fw-medium"
                  >{{ bill.customer ? printName(bill.customer, 'customers') : '' }}</span>
                </div>
                <div class="col px-0" v-if="isPayInvoice">
                  <span v-if="bill.customer" v-translate>Customer Signature:</span>
                </div>
                <div class="col text-right ml-auto pl-0">
                  <span class="date-lg">{{ printDate(bill.updatedDate) }}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-body">
            <order-grouped
              :group="groupedOrder[groupViewed]"
              v-if="false && groupViewed < groupedOrder.length"
            />
            <order-list-modal v-else />
          </div>
          <div class="text-center pb-4">
            <div v-if="groupViewed == groupedOrder.length">
              <span v-translate>Last order served by:</span>
              <span>{{ $store.getters.printStaffName(bill.staff) }} (#{{ printProperty(bill.staff, 'staffs', 'ref') }})</span>
            </div>
            <p class="mb-3">
              <span v-translate>Bill opened at:</span>
              {{ printDate(bill.createdDate) }}
            </p>
            <p
              v-if="groupViewed == groupedOrder.length"
              class="mb-2 fw-medium text-uppercase"
              v-translate
            >Thanks for your visit</p>
            <button
              class="btn btn-default px-5 d-print-none mx-2"
              @click="handlePrint"
              :disabled="disablePrint"
              v-translate
            >Print</button>
            <button
              class="btn btn-default px-5 d-print-none mx-2"
              @click="handleExit"
              v-translate
            >Exit</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import OrderListModal from '@/components/OrderListModal.vue';
import OrderGrouped from '@/components/OrderGrouped.vue';

import {
  RESET_ALL_TOGGLE,
  TOGGLE_BILL_MODAL_VISIBLE,
  SET_MESSAGE_MODAL,
} from '@/store/mutation-types';

import BillService from '@/services/BillService';

export default {
  name: 'BillModal',
  data() {
    return {
      groupViewed: 0,
      printer: null,
      disablePrint: false
    };
  },
  components: {
    OrderListModal,
    OrderGrouped,
  },
  computed: {
    groupedOrder() {
      if (['detail', 'close', 'split', 'merge'].indexOf(this.billModal) != -1) {
        return [];
      }
      const groupedOrder = [];
      let items = this.previousOrder;
      if (this.billModal == 'new') {
        items = [];
        const firstItemOfLastOrder = this.previousOrderSeparators[
          this.previousOrderSeparators.length - 1
        ];
        this.previousOrder.forEach((item, index) => {
          if (index >= firstItemOfLastOrder) {
            items.push(item);
          }
        });
      }
      items.forEach((item) => {
        /* Skip credit back item */
        if (item.qty < 0) return;
        let productGroup = null;
        let orderLevel = null;
        // calculate group and level
        if (item.type == this.NORMAL_ITEM 
          || item.type == this.COMMISSION_ITEM 
          || item.type == this.TIMER_ITEM 
        ) {
          let article = this.getObject(item.product, 'articles');
          if(article) {
            productGroup = article.productGroup;
          }
          if (item.orderLevel) {
            orderLevel = item.orderLevel;
          }
        } else if (item.type == this.MIXER_ITEM) {
          const mixer = this.getObject(item.product, 'articles');
          if (mixer.productGroup && mixer.orderLevel) {
            productGroup = mixer.productGroup;
            orderLevel = mixer.orderLevel;
          } else {
            const parent = this.getItemParent(item.parent);
            productGroup = this.getObject(parent.product, 'articles')
              .productGroup;
            if (parent.orderLevel) {
              orderLevel = parent.orderLevel;
            }
          }
        }
        if (!orderLevel) return;

        /* Group */
        const existedGroupIndex = groupedOrder.findIndex(
          group => group.id === productGroup,
        );
        if (existedGroupIndex === -1) {
          const level = this.getObject(orderLevel, 'orderLevels');
          groupedOrder.push({
            id: productGroup,
            levels: [
              {
                id: level.id,
                indexNumber: level.indexNumber,
                items: [item],
              },
            ],
          });
          return;
        }

        /* Level */
        const { levels } = groupedOrder[existedGroupIndex];
        const existedLevelIndex = levels.findIndex(
          level => level.id === orderLevel,
        );
        if (existedLevelIndex !== -1) {
          levels[existedLevelIndex].items.push(item);
        } else {
          const level = this.getObject(orderLevel, 'orderLevels');
          if(level) {
            levels.push({
              id: level.id,
              indexNumber: level.indexNumber,
              items: [item],
            });
          } else {
            levels.push({
              id: 0,
              indexNumber: 0,
              items: [item],
            });
          }
        }
      });
      groupedOrder.forEach((group) => {
        group.levels = group.levels.sort((a, b) => (a.indexNumber > b.indexNumber ? 1 : -1));
      });
      return groupedOrder;
    },
    billModal: {
      get() {
        return this.getMap('billModal', true);
      },
      set(value) {
        this.$store.state.bill.billModal = value;
      },
    },
    previousOrder() {
      return this.getMap('previousOrder', true);
    },
    location() {
      return this.getMap('user', true).location;
    },
    station() {
      return this.getMap('user', true).station;
    },
    secondBill: {
      get() {
        return this.getMap('secondBill', true);
      },
      set(value) {
        this.$store.state.bill.secondBill = value;
      },
    },
    firstBill: {
      get() {
        return this.getMap('firstBill', true);
      },
      set(value) {
        this.$store.state.bill.firstBill = value;
      },
    },
    ...mapState({
      bill: state => state.bill.bill,
      message: state => state.toggle.messageModal,
    }),
    ...mapGetters([
      'isBill',
      'previousOrderSeparators',
      'getItemParent',
      'isPayInvoice',
    ]),
  },
  methods: {
    ...mapMutations([SET_MESSAGE_MODAL]),
    async handlePrint() {
      this.disablePrint = true;
      let mode = 0;
      if (
        this.billModal == 'reprint'
        || (this.billModal == 'detail' && this.bill.status == 0)
      ) {
        mode = 3;
      }
      const noProductGroup = (typeof (this.secondBill.id) !== 'undefined'
                              || typeof (this.firstBill.id) !== 'undefined'
                              || this.$route.name === 'merge-bill')
        ? 1 : 0;
      const data = await BillService.getPrintData(this.bill.id, mode, noProductGroup);
      this.handleExit();
      if (data && !data.error) {
        await this.$store.dispatch('print', { billData: data, printProductTicket: false });
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
      this.disablePrint = false;
    },
    handleExit() {
      if (false && this.groupViewed < this.groupedOrder.length) {
        this.groupViewed++;
      } else {
        this.groupViewed = this.groupedOrder.length + 1;
        this.$store.dispatch('resetBill');
        this.$store.commit(RESET_ALL_TOGGLE);
        if (
          this.$route.name === 'void-bill'
          || this.$route.name === 'pay-cash'
          || this.$route.name === 'pay'
        ) {
          this.$router.push('order');
        }
        if (this.secondBill.id && !this.firstBill.id) {
          this.secondBill = { empty: true };
          this.$router.push({ name: 'order' });
          this.$store.commit(TOGGLE_BILL_MODAL_VISIBLE, false);
          return;
        }
        if (this.secondBill.id && this.firstBill.id) {
          this.billModal = 'split';
          this.firstBill = { empty: true };
          this.$store.dispatch('setBill', Object.assign({}, this.secondBill));
          this.$store.commit(TOGGLE_BILL_MODAL_VISIBLE, true);
        } else if (
          this.$route.name === 'split-bill'
          || this.$route.name === 'merge-bill'
        ) {
          this.$router.push({ name: 'order' });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  tr {
    td,
    th {
      border-top: none;
    }
  }
}
.modal-bill-print {
  margin-left: auto;
  margin-right: auto;
}
</style>
